const actionScope = '[Medallia]';

export class LoadMedalliaInfo {
  static readonly type = `${actionScope} Load Medallia Info`;
}
